import React, { useState } from 'react'
import { Layout } from '@components/Layout'
import { Helmet } from 'react-helmet'
import InputField from '@components/common/InputField'

const RequestAReturn = () => {
	const [orderNum, setOrderNum] = useState('')
	const [email, setEmail] = useState('')
	const [verificationCode, setVerificationCode] = useState('')

	const handleSubmit = () => {

	}

	const handleVerifyEmail = (e) => {
		e.preventDefault()
	}

	return (
		<Layout gaEvent={{
			eventName: 'page_view',
			params: {
				page_path: '/request-a-return',
				page_title: `Blackbough Swim: Request A Return`,
				queryName: 'request a return page',
			},
		}}>
			<Helmet>
				<title>Blackbough Swim: Request A Return</title>
				<meta name="description" content="Find your new favorite bikini. Shop triple-lined, sustainably-made swimwear in the cutest prints and flattering styles for your every sun-soaked adventure." />
			</Helmet>

			<section className='max-container w-screen md:w-full space-y-5 pt-8 px-4'>
				<p className='text-3xl lg:text-5xl text-[#3D3D3D] text-center'>Blackbough Swim Returns 2025</p>

				<div className='bg-white p-4 mx-auto max-w-[640px]'>
					<p className='text-xl'>Return Order</p>
					<form onSubmit={handleSubmit} className='flex flex-col gap-4 pt-6 request-form'>
						<div>
							<div>
								<InputField
									id="orderNum"
									label="Order Number/Tracking Number"
									placeholder="Enter your order number/tracking number"
									value={orderNum}
									onChange={(e) => setOrderNum(e.target.value)}
									aria-label={"order number/tracking number"}
									labelOnTop
								/>
							</div>
						</div>

						<div>
							<div>
								<InputField
									id="email"
									label="Email Address"
									placeholder="enter your registered email address"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									aria-label={"email"}
									labelOnTop
								/>
							</div>

							<button
								type='button'
								className='btn-outline h-min col-span-2 md:col-span-1 self-end max-h-[38px]'
								aria-label='Verify'
								onClick={handleVerifyEmail}
							>
								Verify
							</button>

							<p className='text-xs text-[#5D5D5D] col-span-4 md:col-span-3'>
								To verify your ownership of the order, please ensure that the email address provided
								matches the one used during the order placement. Verification code will be sent to the provided email.
							</p>
						</div>

						<div>
							<div>
								<InputField
									id="verificationCode"
									label="Verification Code"
									placeholder="Enter verification code sent to the linked email"
									value={verificationCode}
									onChange={(e) => setVerificationCode(e.target.value)}
									aria-label={"verification code"}
									labelOnTop
								/>
							</div>

							<p className='text-xs text-[#5D5D5D] col-span-3'>
								After you click verify, verification code will be sent to the provided email.
								Copy the code from the email and enter it as the verification code to confirm your order.
								You can request a code resend every 120 seconds.
							</p>
						</div>

						<button
							className='btn-primary md:max-w-[180px] mt-4'
							aria-label='submit'
						>
							Submit
						</button>
					</form>
				</div>

			</section>
		</Layout>
	)
}

export default RequestAReturn